import { defineStore } from "pinia";
import base from "./base"


export const useRefurbishmentStore = defineStore('refurb', {
    state: () => ({
        rsos: [],
        work_orders: [],
        last_rsos_unfiltered: [],
        last_work_orders_unfiltered: [],
    }),
    getters: {

    },
    actions: {
        // Reset store
        resetStore() {
            this.rsos = []
            this.work_orders = []
            this.last_rsos_unfiltered = []
            this.last_work_orders_unfiltered = []
        },

        // Sync mutations
        setRSOs: base.actions.setter("rsos"),
        createRSO: base.actions.creator("rsos"),
        createRSOInLastRSOsUnfiltered: base.actions.creator("last_rsos_unfiltered"),
        updateRSO: base.actions.updater("rsos"),
        updateRSOInLastRSOsUnfiltered: base.actions.updater("last_rsos_unfiltered"),
        removeRSO: base.actions.remover("rsos"),

        // Async backend actions
        loadRSOs: base.actions.loader("rsos/", "RSOs"),
        refreshRSO: base.actions.refresher("rsos/", "RSO"),
        postRSO: base.actions.poster("rsos/", ["RSO", "RSOInLastRSOsUnfiltered"]),
        putRSO: base.actions.putter("rsos/", ["RSO", "RSOInLastRSOsUnfiltered"]),
        deleteRSO: base.actions.deleter("rsos/", "RSO"),

        // Sync mutations
        setWorkOrders: base.actions.setter("work_orders"),
        createWorkOrder: base.actions.creator("work_orders"),
        createWorkOrderInLastWorkOrdersUnfiltered: base.actions.creator("last_work_orders_unfiltered"),
        updateWorkOrder: base.actions.updater("work_orders"),
        updateWorkOrderInLastWorkOrdersUnfiltered: base.actions.updater("last_work_orders_unfiltered"),
        removeWorkOrder: base.actions.remover("work_orders"),

        // Async backend actions
        loadWorkOrders: base.actions.loader("work-orders/", "WorkOrders"),
        refreshWorkOrder: base.actions.refresher("work-orders/", "WorkOrder"),
        postWorkOrder: base.actions.poster("work-orders/", ["WorkOrder", "WorkOrderInLastWorkOrdersUnfiltered"]),
        putWorkOrder: base.actions.putter("work-orders/", ["WorkOrder", "WorkOrderInLastWorkOrdersUnfiltered"]),
        deleteWorkOrder: base.actions.deleter("work-orders/", "WorkOrder"),

        // Cache helpers for Work Orders
        setLastWorkOrdersUnfiltered(data) {
            // Store an immutable snapshot
            this.last_work_orders_unfiltered = Array.isArray(data) ? [...data] : []
        },
        loadWorkOrdersCached(params = undefined) {
            const hasParams =
                params &&
                Object.keys(params).some(k => params[k] !== null && params[k] !== undefined && params[k] !== '')
            // If filters are provided, snapshot current unfiltered list (once) and delegate to loader
            if (hasParams) {
                if (
                    (!this.last_work_orders_unfiltered || this.last_work_orders_unfiltered.length === 0) &&
                    Array.isArray(this.work_orders) && this.work_orders.length > 0
                ) {
                    this.setLastWorkOrdersUnfiltered(this.work_orders)
                }
                return this.loadWorkOrders(params)
            }
            // No filters: if we have cache, restore without refetch
            if (this.last_work_orders_unfiltered && this.last_work_orders_unfiltered.length > 0) {
                this.setWorkOrders([...this.last_work_orders_unfiltered])
                return Promise.resolve(this.last_work_orders_unfiltered)
            }
            // No cache available: fetch and cache
            return this.loadWorkOrders()
                .then(data => {
                    this.setLastWorkOrdersUnfiltered(data)
                    return data
                })
        },

        // Cache helpers for RSOs
        setLastRSOsUnfiltered(data) {
            // Store an immutable snapshot
            this.last_rsos_unfiltered = Array.isArray(data) ? [...data] : []
        },
        loadRSOsCached(params = undefined) {
            const hasParams =
                params &&
                Object.keys(params).some(k => params[k] !== null && params[k] !== undefined && params[k] !== '')
            // If filters are provided, snapshot current unfiltered list (once) and delegate to loader
            if (hasParams) {
                if (
                    (!this.last_rsos_unfiltered || this.last_rsos_unfiltered.length === 0) &&
                    Array.isArray(this.rsos) && this.rsos.length > 0
                ) {
                    this.setLastRSOsUnfiltered(this.rsos)
                }
                return this.loadRSOs(params)
            }
            // No filters: if we have cache, restore without refetch
            if (this.last_rsos_unfiltered && this.last_rsos_unfiltered.length > 0) {
                this.setRSOs([...this.last_rsos_unfiltered])
                return Promise.resolve(this.last_rsos_unfiltered)
            }
            // No cache available: fetch and cache
            return this.loadRSOs()
                .then(data => {
                    this.setLastRSOsUnfiltered(data)
                    return data
                })
        },

    }
})
